import { React, useEffect, useState, useRef, useContext } from 'react'
import { motion, AnimatePresence, delay, useAnimation } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import logo from '../Images/logo.png'
import FormComponent from '../components/FormComponents/FormComponent';
import PortalComponents from '../components/PortalComponents/PortalComponents';
import { Chart } from 'primereact/chart';
import { Button } from "@nextui-org/react";
import { Avatar } from "@nextui-org/react";
import { VictoryBar } from 'victory';
import { Card, CardHeader, CardBody } from "@nextui-org/react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPen, faUsers, faUserShield, faGift, faUserCog, faListCheck, faArrowLeft, faClock, faCheck, faCircle, faCircleXmark, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import SidePanel from '../components/SidePanel/SidePanel';
import { Routes, Route, useNavigate } from 'react-router-dom';
import DataList from './Components/DataList';
import './StaffPanel.css'
import BackEndUrl from '../backURL';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import LogoutButton from '../components/Logout/LogoutButton';

import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { StaffContext } from './Services/staff.context';

import DataListRejected from './Components/DataListRejected';
import DataListAccepted from './Components/DataListAccepted';
import DataListCompleted from './Components/DataListCompleted';
import DataListContactUs from './Components/DataListContactUs';
const backend = BackEndUrl.domain;
function getRandomRgbColor() {
  const randomColorComponent = () => Math.floor(Math.random() * 256);

  const red = randomColorComponent();
  const green = randomColorComponent();
  const blue = randomColorComponent();

  return `rgb(${red}, ${green}, ${blue})`;
}
const StaffPanel = () => {

  const [policies, setPolicies] = useState(null);
  const [staff, setStaff] = useState(null);
  const [PendingChartOptions, setPendingChartOptions] = useState({});
  const [AcceptedChartOptions, setAcceptedChartOptions] = useState({});
  const [RejectedChartOptions, setRejectedChartOptions] = useState({});
  const [PendingChartData, setPendingChartData] = useState({});
  const [AcceptedChartData, setAcceptedChartData] = useState({});
  const [RejectedChartData, setRejectedChartData] = useState({});
  const [selectedReq, setselectedReq] = useState(null);
  const controls = useAnimation();
  const pendingReqs = useContext(StaffContext).pendingRequests
  const acceptedRequests = useContext(StaffContext).acceptedRequests
  const rejectedRequests = useContext(StaffContext).rejectedRequests
  const completedRequests = useContext(StaffContext).completedRequests

  const pendingReqsContactUs = useContext(StaffContext).pendingRequestsContactUs
  const noOfPendingReqsContactUs = useContext(StaffContext).noOfPendingRequestsContactUs


  useEffect(() => {



    async function Getstaff() {
      try {
        const response = await axios.post(backend + "/is-staff",
          {
            nic: sessionStorage.getItem('nic'),
            mobile: sessionStorage.getItem('mobile'),
          }, {
          headers: {
            Authorization: sessionStorage.getItem('staff-token'),
          }
        }
        );
        setStaff(response.data > 0 ? "1" : "0");
        sessionStorage.setItem("full_name", `${response.data[0].fname} ${response.data[0].lname}`)

      } catch (error) {
        console.log(error);
      }
    }


    if (!staff) {
      Getstaff();
    }


  }, [policies]);

  useEffect(() => {

    controls.start({
      scale: [0, 1],
      transition: { duration: 0.25 },
    }
    )


  }, [pendingReqs && pendingReqs.length, acceptedRequests && acceptedRequests.length]);






  const checkAccess = staff && staff == "1"
  if (sessionStorage.getItem("staff-token")) {
    if (checkAccess != null) {
      if (checkAccess == true && sessionStorage.getItem("staff-logged")) {

        return (
          <>
            <Row className='d-flex justify-content-between header '  style={{ height:"100px",backgroundColor: "#3468C0", paddingTop:"5px",paddingBottom:"5px",paddingLeft:"80px", paddingRight:"80px" }}>
              <Col xs={3} style={{alignContent:"center"}}  >
                <img src={logo} style={{ height:"auto", width: "25%",backgroundColor:"white" , borderRadius: "10px" }} />
              </Col>
              <Col xs={3} className='mx-3 my-3 d-flex justify-content-center align-items-center'  >
                <h1 style={{ fontSize: "25px", color:"white" , fontWeight:"bold"}}>STAFF PANEL</h1>
              </Col>

              <Col xs={3} className='d-flex align-items-center justify-content-end me-3' >
                <motion.div initial={{ opacity: 0, x: "100%" }} animate={{ opacity: 1, x: "0%", transition: { duration: 0.5, } }} className='d-flex align-items-center justify-content-end ' >

                <div style={{marginRight:"10px" }}>
                  <PortalComponents
                    type="avatar-dropdown"
                    cusName={sessionStorage.getItem("full_name")}
                  >               

                  </PortalComponents>
                  </div>

                  <LogoutButton isstaff={"Yes"} />
                </motion.div>
              </Col>
            </Row>
            {selectedReq == null &&
              <Row style={{ display: 'flex', justifyContent: 'center', height: '100vh', margin:"8px" , paddingLeft:"20px", paddingRight:"20px" }}>
                <Col xs={12} >
                  <Row>

                  <h1 style={{fontSize:"22px", textTransform:"uppercase",fontWeight:"bold" ,margin:"10px 0 10px 0"}}>policy holder's - requests</h1>


                    <Col xs={6} md={3}>
                      <motion.div


                        whileTap={{ scale: 0.5 }}
                        onClick={() => { setselectedReq("pendingreq") }}

                      >
                        <Card className="py-4 my-2" style={{ width: "100%", height: "30vh", backgroundColor: "#FF9843" , cursor: "pointer" }} >


                          <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center", position: "relative" }}
                          >

                            {pendingReqs && pendingReqs.length > 0 &&
                              <motion.div
                                key={`static-key`}
                                initial={{
                                  scale: 0.5
                                }}
                                animate={controls}
                                style={{ width: "30px", height: "30px", backgroundColor: "red", borderRadius: "50%", position: "absolute", right: "1%", top: "-10%", color: "white", fontSize: "15px" }} className='d-flex justify-content-center align-items-center'>


                                <div>
                                  {pendingReqs.length}
                                </div>

                              </motion.div>}


                            <FontAwesomeIcon icon={faClock} style={{ height: "4vh", color: "white" }} />
                            <p style={{ fontSize: "20px", width: "75%", color: "white" }} className='py-4'> Pending Requests</p>


                          </CardBody>
                        </Card>
                      </motion.div>
                      {/* <Chart type="bar" data={PendingChartData} options={PendingChartOptions} style={{ backgroundColor: "#F7941E", padding: "2vh", borderRadius: "1.3em" }} /> */}
                    </Col>
                    <Col xs={6} md={3}>
                      <motion.div


                        whileTap={{ scale: 0.5 }}
                        onClick={() => { setselectedReq("acceptedreq") }}

                      >
                        <Card className="py-4 my-2" style={{ width: "100%", height: "30vh", backgroundColor: "#3468C0", cursor: "pointer" }} >


                          <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center", position: "relative" }}
                          >

                            {acceptedRequests && acceptedRequests.length > 0 &&
                              <motion.div
                                key={`static-key`}
                                initial={{
                                  scale: 0.5
                                }}
                                animate={controls}
                                style={{ width: "30px", height: "30px", backgroundColor: "red", borderRadius: "50%", position: "absolute", right: "1%", top: "-10%", color: "white", fontSize: "15px" }} className='d-flex justify-content-center align-items-center'>


                                <div>
                                  {acceptedRequests.length}
                                </div>

                              </motion.div>}


                            <FontAwesomeIcon icon={faCheck} style={{ height: "4vh", color: "white" }} />
                            <p style={{ fontSize: "20px", width: "75%", color: "white" }} className='py-4'>  Accepted Requests</p>


                          </CardBody>
                        </Card>
                      </motion.div>
                      {/* <Chart type="bar" data={AcceptedChartData} options={AcceptedChartOptions} style={{ backgroundColor: "#24c224", padding: "2vh", borderRadius: "1.3em" }} /> */}
                    </Col>
                    <Col xs={6} md={3}>
                      <motion.div


                        whileTap={{ scale: 0.5 }}
                        onClick={() => { setselectedReq("rejectedreq") }}

                      >
                        <Card className="py-4 my-2" style={{ width: "100%", height: "30vh", backgroundColor: "#EE4E4E" , cursor: "pointer"}} >


                          <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center", position: "relative" }}
                          >

                            {rejectedRequests && rejectedRequests.length > 0 &&
                              <motion.div
                                key={`static-key`}
                                initial={{
                                  scale: 0.5
                                }}
                                animate={controls}
                                style={{ width: "30px", height: "30px", backgroundColor: "red", borderRadius: "50%", position: "absolute", right: "1%", top: "-10%", color: "white", fontSize: "15px" }} className='d-flex justify-content-center align-items-center'>


                                <div>
                                  {rejectedRequests.length}
                                </div>

                              </motion.div>}


                            <FontAwesomeIcon icon={faCircleXmark} style={{ height: "4vh", color: "white" }} />
                            <p style={{ fontSize: "20px" , width: "75%", color: "white" }} className='py-4'>  Rejected Requests</p>


                          </CardBody>
                        </Card>
                      </motion.div>
                      {/* <Chart type="bar" data={RejectedChartData} options={RejectedChartOptions} style={{ backgroundColor: "#ff080c", padding: "2vh", borderRadius: "1.3em" }} /> */}
                    </Col>

                    <Col xs={6} md={3}>
                      <motion.div


                        whileTap={{ scale: 0.5 }}
                        onClick={() => { setselectedReq("completedreq") }}

                      >
                        <Card className="py-4 my-2" style={{ width: "100%", height: "30vh", backgroundColor: "#059212" , cursor: "pointer"}} >


                          <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center", position: "relative" }}
                          >

                            {completedRequests && completedRequests.length > 0 &&
                              <motion.div
                                key={`static-key`}
                                initial={{
                                  scale: 0.5
                                }}
                                animate={controls}
                                style={{ width: "30px", height: "30px", backgroundColor: "red", borderRadius: "50%", position: "absolute", right: "1%", top: "-10%", color: "white", fontSize: "15px" }} className='d-flex justify-content-center align-items-center'>


                                <div>
                                  {completedRequests.length}
                                </div>

                              </motion.div>}

                              <FontAwesomeIcon icon={faClipboardCheck} style={{ height: "4vh", color: "white" }} />
                          
                            <p style={{ fontSize: "20px", width: "75%", color: "white" }} className='py-4'> Completed Requests</p>


                          </CardBody>
                        </Card>
                      </motion.div>
                      {/* <Chart type="bar" data={PendingChartData} options={PendingChartOptions} style={{ backgroundColor: "#F7941E", padding: "2vh", borderRadius: "1.3em" }} /> */}
                    </Col>

                      {/* Contact us Prending Requests             */}
                      {/* Contact us Prending Requests             */}

                    <h1 style={{fontSize:"22px", textTransform:"uppercase",fontWeight:"bold" ,margin:"10px 0 10px 0"}}>Contact us - requests</h1>
                     
                    <Col xs={6} md={3}>
                      <motion.div


                        whileTap={{ scale: 0.5 }}
                        onClick={() => { setselectedReq("contactpendingreq") }}

                      >
                        <Card className="py-4 my-2" style={{ width: "100%", height: "30vh", backgroundColor: "#5E1675" , cursor: "pointer" }} >


                          <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center", position: "relative" }}
                          >

                            {noOfPendingReqsContactUs && noOfPendingReqsContactUs.length > 0 &&
                              <motion.div
                                key={`static-key`}
                                initial={{
                                  scale: 0.5
                                }}
                                animate={controls}
                                style={{ width: "30px", height: "30px", backgroundColor: "red", borderRadius: "50%", position: "absolute", right: "1%", top: "-10%", color: "white", fontSize: "15px" }} className='d-flex justify-content-center align-items-center'>


                                <div>
                                  {noOfPendingReqsContactUs.length}
                                </div>

                              </motion.div>}


                            <FontAwesomeIcon icon={faClock} style={{ height: "4vh", color: "white" }} />
                            <p style={{ fontSize: "20px", width: "75%", color: "white" }} className='py-4'> All Requests</p>


                          </CardBody>
                        </Card>
                      </motion.div>
                      {/* <Chart type="bar" data={PendingChartData} options={PendingChartOptions} style={{ backgroundColor: "#F7941E", padding: "2vh", borderRadius: "1.3em" }} /> */}
                    </Col>
                    



                    {/* Contact us Prending Requests             */}
                    {/* Contact us Prending Requests             */}


                  </Row>

                  {/* new row */}
                  <Row className='d-flex justify-content-center'>

                  </Row>
                </Col>

              </Row>
            }

            {
              selectedReq == "pendingreq" &&
              <Row className='d-flex justify-content-center mt-3'>
                <Col xs={11}>
                
                  <DataList setselectedReq={setselectedReq} />

                </Col>
              </Row>
            }
            {
              selectedReq == "completedreq" &&
              <Row className='d-flex justify-content-center mt-3'>
                <Col xs={11}>
                
                  <DataListCompleted setselectedReq={setselectedReq} />

                </Col>
              </Row>
            }
             {
              selectedReq == "acceptedreq" &&
              <Row className='d-flex justify-content-center mt-3'>
                <Col xs={11}>
                
                  <DataListAccepted setselectedReq={setselectedReq} />

                </Col>
              </Row>
            }
            {
              selectedReq == "rejectedreq" &&
              <Row className='d-flex justify-content-center mt-3'>
                <Col xs={11}>
                
                  <DataListRejected setselectedReq={setselectedReq} />

                </Col>
              </Row>
            }
            {
              selectedReq == "contactpendingreq" &&
              <Row className='d-flex justify-content-center mt-3'>
                <Col xs={11}>
                
                  <DataListContactUs setselectedReq={setselectedReq} />

                </Col>
              </Row>
            }
          </>
        )
      }
      else if (checkAccess == false) {
        window.location.href = "/customer-portal/staff-login"
      }

    } else {
      <LoadingScreen />
    }
  } else {
    window.location.href = "/customer-portal/staff-login"
  }

}

export default StaffPanel
